export enum SearchPresetSuffix {
  KEYWORD = 'keyword',
  HYBRID = 'hybrid',
  SEMANTIC = 'semantic',
}
